import { Injectable } from '@angular/core';
import { IFAFeatures, InboxDto } from '@app/core/model';
import { LineOfBusiness, ProductNames } from '@mynexus/mynexus-ui-lib';

@Injectable()
export class PlatformService {
  private feats: Partial<Record<IFAFeatures, boolean>> = {};

  public set features(value: Partial<Record<IFAFeatures, boolean>>) {
    this.feats = value;
  }

  get features() {
    return this.feats;
  }

  // Tech-debt TODO: Refactor with Inbox ViewModel approach and read in available
  // fax actions from there instead of determining logic on the front end. See #221947
  getAvailableFaxActions(inbox: InboxDto): Record<string, boolean> {
    const isVisible: Record<string, boolean> = {
      CreateNewAuthorization: false,
      AttachToAuthorization: false,
      AddNewLine: false,
    };

    // Uncomment feature flags as each product implements each fax action
    // TODO: Remove PAC Commercial after LOB migration
    const product = inbox.tenantLobProduct?.productShortName;
    switch (product) {
      case ProductNames.DMEPOS:
        isVisible['CreateNewAuthorization'] = this.features.ifaActionDMEPOSAuth;
        isVisible['AttachToAuthorization'] = this.features.ifaActionDMEPOSAttachDocument;
        // Note: DME does not have add new line, so no additional configuration is needed
        break;
      case ProductNames.PACIM:
      case ProductNames.PacCommercial:
        if (inbox.tenantLobProduct?.lineOfBusiness === LineOfBusiness.Commercial) {
          isVisible['CreateNewAuthorization'] = this.features.ifaActionPACComAuth;
          isVisible['AttachToAuthorization'] = this.features.ifaActionPACComAttachDocument;
          isVisible['AddNewLine'] = this.features.ifaActionPACComLine;
        } else {
          isVisible['CreateNewAuthorization'] = this.features.ifaActionPACIMAuth;
          isVisible['AttachToAuthorization'] = this.features.ifaActionPACIMAttachDocument;
          isVisible['AddNewLine'] = this.features.ifaActionPACIMLine;
        }
        break;
      case ProductNames.HomeHealth:
        isVisible['CreateNewAuthorization'] = this.features.ifaActionHHAuth;
        isVisible['AttachToAuthorization'] = this.features.ifaActionHHAttachDocument;
        isVisible['AddNewLine'] = this.features.ifaActionHHLine;
        break;
      default:
        isVisible['AttachToAuthorization'] = true;
        break;
    }

    return isVisible;
  }
}
